import { shouldPolyfill } from '@formatjs/intl-relativetimeformat/should-polyfill.js';

import { INTL_LOCALE_CHECKS } from '../intlLocale';
import { INTL_PLURAL_RULES_CHECKS } from '../intlPluralRules';

import { loadPolyfill } from './polyfill';

const polyfill = (() => {
	const promises: Partial<Record<string, Promise<void>>> = {};

	return async function innerPolyfill(locale: string) {
		if (promises[locale]) {
			return promises[locale];
		}

		promises[locale] = loadPolyfill(locale, RELATIVE_TIME_FORMAT_CHECKS.dependencies);
		return promises[locale];
	};
})();

const RELATIVE_TIME_FORMAT_CHECKS = {
	name: 'relative-time-format' as const,
	dependencies: [...INTL_PLURAL_RULES_CHECKS, ...INTL_LOCALE_CHECKS],
	// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
	checkNativeIntlFeature: (locale: string): boolean => !!window.Intl && !shouldPolyfill(locale),
	polyfill,
};

export const INTL_RELATIVE_TIME_FORMAT_CHECKS = [RELATIVE_TIME_FORMAT_CHECKS];
